import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import assets from 'modules/assets'

class ArchiveUserBio extends Component {
  constructor(props) {
    super(props)
    this.state = {
      year: props.year,
      archiveData: props.archiveData,
      country: props.country,
      isFetching: props.isFetching
    }
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      year: nextProps.year,
      isFetching: nextProps.isFetching,
      archiveData: nextProps.archiveData,
      country: nextProps.country,
      selectedUser: nextProps.country !== this.state.country ? null : nextProps.selectedUser
    })
  }
  team(country) {
    if (!this.state.isFetching && this.state.archiveData) {
      return this.state.archiveData.filter(location => {
        return location.country === country
      })[0]
    } else {
      return { members: [] }
    }
  }
  user(countryData) {
    if (!this.state.isFetching && this.state.archiveData && this.state.selectedUser) {
      return countryData.members.filter(user => {
        return user.id === this.state.selectedUser
      })[0]
    } else if (this.state.archiveData) {
      return countryData.members[0]
    } else {
      return {
        title: '',
        name: '',
        school: '',
        bio: ''
      }
    }
  }
  render() {
    let country = this.team(this.state.country)
    let user = this.user(country)

    let title, name, school, bio
    if (!this.state.isFetching && typeof user !== 'undefined') {
      title = user.title
      name = user.name
      school = user.school
      bio = user.bio
    }

    return (
      <div className='description group'>
        <h5>{name}</h5>
        <h6>{school}</h6>
        <p>{bio}</p>
      </div>
    )
  }
}
ArchiveUserBio.contextTypes = {
}
ArchiveUserBio.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
    selectedUser: state.token.selectedUser
  }
}

export default connect(mapStateToProps)(ArchiveUserBio)



// WEBPACK FOOTER //
// ./src/components/Archive/ArchiveUserBio.js